import React from 'react';
import { Button } from './ui/button';
import { DollarSign } from 'lucide-react';

const FinancingSection = () => {
  return (
    <section className="py-16">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src="https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=800&q=80"
              alt="Financing"
              className="w-full rounded-lg shadow-lg"
            />
          </div>
          <div>
            <div className="mb-6">
              <DollarSign size={48} className="text-gray-700" />
            </div>
            <h2 className="text-3xl font-light mb-4 text-gray-800">
              Financing Options
            </h2>
            <p className="text-gray-600 mb-4 leading-relaxed">
              For online purchases, we offer financing services through ShopPay for domestic clients and financing services through Global-E for international clients. This option allows us to create and ship your ring as you continue to make payments.
            </p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              For in-person purchases, we also offer financing services through Synchrony Bank for domestic clients.
            </p>
            <Button
              variant="outline"
              className="border-gray-800 text-gray-800 hover:bg-gray-800 hover:text-white transition-all duration-300"
            >
              Learn More
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinancingSection;